import { ThemeOptions } from '@mui/material/styles'

export const sharedTheme: ThemeOptions = {
  typography: {
    fontFamily: 'proxima-nova, Arial, sans-serif',
    h1: {
      fontSize: '25px',
      fontWeight: 700,
    },
    h2: {
      fontSize: '22px',
      fontWeight: 700,
    },
    h3: {
      fontSize: '18px',
      fontWeight: 700,
    },
    h4: {
      fontSize: '16px',
      fontWeight: 700,
    },
    h5: {
      fontSize: '14px',
      fontWeight: 700,
    },
    body1: {
      fontSize: '16px',
    },
    button: {
      fontSize: '16px',
      fontWeight: 700,
      textTransform: 'none',
    },
  },
  palette: {
    text: {
      secondary: '#434343',
    },
    background: {
      default: '#ffffff', // you can set this to your desired default background
      paper: '#ffffff',
      // For your custom grey background color, better to add it separately (see below)
    },
  },
  // Custom properties outside palette/typography:
  borders: {
    grey: '#E7E7E7',
  },
  customColors: {
    backgroundGrey: '#F5F6F7',
  },
}
